import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { CallRouteV1 } from '@frontend/api-call-route';
import { useTranslation } from '@frontend/i18n';
import { Chip } from '@frontend/design-system';
import { SharedNodeProps } from '../data';
import { draggableStyles } from './styles';

export const HoursTypeNode = memo(({ type }: SharedNodeProps) => {
  const { t } = useTranslation('phone');

  if (
    type !== CallRouteV1.Types.NodeType.NODE_TYPE_OPEN_HOURS &&
    type !== CallRouteV1.Types.NodeType.NODE_TYPE_CLOSED_HOURS
  ) {
    throw new Error('Invalid node type for HoursTypeNode');
  }

  const handles = {
    top: { id: 'top' },
    bottom: { id: 'bottom' },
  };
  return (
    <div>
      <Handle
        type='target'
        position={Position.Top}
        id={handles.top.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />

      {/* Open Hours */}
      {type === CallRouteV1.Types.NodeType.NODE_TYPE_OPEN_HOURS && (
        <Chip css={draggableStyles} variant='success'>
          {t('Open')}
        </Chip>
      )}

      {/* Closed Hours */}
      {type === CallRouteV1.Types.NodeType.NODE_TYPE_CLOSED_HOURS && (
        <Chip css={draggableStyles} variant='critical'>
          {t('Closed')}
        </Chip>
      )}

      <Handle
        type='source'
        position={Position.Bottom}
        id={handles.bottom.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
    </div>
  );
});
HoursTypeNode.displayName = 'HoursTypeNode';
